import React, { Component } from "react";
import { connect } from "react-redux";
import { CreateHotel } from "./CreateHotel";
import { translate } from "react-i18next";
import { getHotels } from "../actions";
class CreateHotelContainer extends Component {
  componentDidMount() {
    if (this.props.hotels.length === 0) {
      this.props.getHotels();
    }
    if (this.props.hotels.length > 0) {
      this.props.history.push("/");
    }
  }
  componentDidUpdate() {
    if (this.props.hotels.length > 0) {
      this.props.history.push("/");
    }
  }

  render() {
    return <CreateHotel {...this.props} />;
  }
}

const mapStateToProps = state => {
  return {
    hotels: state.hotels.data
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getHotels: () => {
      dispatch(getHotels());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(CreateHotelContainer));



// WEBPACK FOOTER //
// ./src/hotels/CreateHotel/index.js